class BulkOrderForm extends HTMLElement {
  constructor() {
    super();
    this.init();
  }

  init() {
    this.form = this.querySelector('#bulk-order-form');
    this.submitBtn = this.querySelector('.bulk-form__body-btn');
    this.statusDiv = this.querySelector('#form-status');

    this.statusSuccess = this.querySelector('.form-status--success');
    this.statusError = this.querySelector('.form-status--error');

    this.config = {
      // Replace with your deployed Google Apps Script URL
      googleScriptUrl:
        'https://script.google.com/macros/s/AKfycbxWEFkBKcviEJgt38PbP5-4ykP-lq4C45LB5isNWUZoblEaQuAIuMqfRMTVgbmBAB-DWw/exec',

      backupEmail: 'sales@gharsoaps.in',
    };

    if (this.form) {
      this.bindEvents();
      this.initializeStatusMessages();
    }

    this.setupOtherFieldToggle();
  }

  initializeStatusMessages() {
    // Hide status messages initially
    if (this.statusDiv) {
      this.statusDiv.classList.add('hidden');
    }
    if (this.statusSuccess) {
      this.statusSuccess.classList.add('hidden');
    }
    if (this.statusError) {
      this.statusError.classList.add('hidden');
    }
  }

  bindEvents() {
    this.form.addEventListener('submit', (e) => this.handleSubmit(e));
  }

  async handleSubmit(e) {
    e.preventDefault();
    
    try {
      this.setLoading(true);
      this.hideStatusMessages();
      
      const formData = this.getFormData();

      if (!this.validateForm(formData)) {
        this.setLoading(false);
        return;
      }

      await this.saveToGoogleSheets(formData);

      this.showSuccess();
      this.form.reset();
      
    } catch (error) {
      this.showError('Something went wrong. Please try again or contact us directly.');
    } finally {
      this.setLoading(false);
    }
  }

  getFormData() {
    const formData = new FormData(this.form);
    const data = {};

    for (let [key, value] of formData.entries()) {
      data[key] = value;
    }

    // Explicitly get select field values (FormData can miss disabled default options)
    const selectFields = ['quantity', 'city', 'product'];
    selectFields.forEach(fieldName => {
      const selectEl = this.form.querySelector(`select[name="${fieldName}"]`);
      if (selectEl && selectEl.value) {
        data[fieldName] = selectEl.value;
      }
    });

    data.timestamp = new Date().toISOString();
    console.log('Form data being sent:', data);
    return data;
  }

  validateForm(data) {
    const requiredFields = ['full_name', 'email', 'phone', 'quantity', 'city', 'product', 'purchasing', 'date'];

    for (const field of requiredFields) {
      const value = data[field];
      
      if (!value || value.trim() === '') {
        const errorMsg = `Please fill in the ${field.replace(/_/g, ' ').toLowerCase()} field.`;
        this.showError(errorMsg);
        return false;
      }
    }

    // Validate other_input only if "Other" is selected
    if (data.purchasing === 'Other') {
      if (!data.other_input || data.other_input.trim() === '') {
        const errorMsg = 'Please specify your reason when selecting "Other".';
        this.showError(errorMsg);
        return false;
      }
    }

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(data.email)) {
      const errorMsg = 'Please enter a valid email address.';
      this.showError(errorMsg);
      return false;
    }

    const phoneRegex = /^[\d\s\-\+\(\)]{10,}$/;
    if (!phoneRegex.test(data.phone)) {
      const errorMsg = 'Please enter a valid phone number (at least 10 digits).';
      this.showError(errorMsg);
      return false;
    }

    const selectedDate = new Date(data.date);
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    
    if (selectedDate < today) {
      const errorMsg = 'Please select a delivery date that is today or in the future.';
      this.showError(errorMsg);
      return false;
    }

    return true;
  }

  async saveToGoogleSheets(data) {
    try {
      // Convert data to URL-encoded format for better Google Apps Script compatibility
      const urlEncodedData = new URLSearchParams();
      Object.keys(data).forEach(key => {
        urlEncodedData.append(key, data[key] || '');
      });

      const response = await fetch(this.config.googleScriptUrl, {
        method: 'POST',
        body: urlEncodedData,
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        mode: 'no-cors',
      });

      if (!response.ok && response.status !== 0) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      return true;

    } catch (error) {
      throw new Error('Failed to save data to Google Sheets');
    }
  }

  setLoading(isLoading) {
    const button = this.submitBtn;
    
    if (!button) {
      return;
    }

    if (isLoading) {
      button.disabled = true;
      button.textContent = 'Submitting...';
      button.style.opacity = '0.7';
      button.style.cursor = 'not-allowed';
    } else {
      button.disabled = false;
      button.textContent = 'Submit';
      button.style.opacity = '1';
      button.style.cursor = 'pointer';
    }
  }

  setupOtherFieldToggle() {
  const radios = this.form.querySelectorAll('input[name="purchasing"]');
  const otherInputWrapper = this.form.querySelector('#other-input-wrapper');

  radios.forEach(radio => {
    radio.addEventListener('change', () => {
      if (radio.value === 'Other' && radio.checked) {
        otherInputWrapper.classList.add('show-animated');
        otherInputWrapper.classList.remove('hidden-animated');
      } else if (radio.checked) {
        otherInputWrapper.classList.add('hidden-animated');
        otherInputWrapper.classList.remove('show-animated');
      }
    });
  });

  // Ensure correct state on initial load
  const checked = this.form.querySelector('input[name="purchasing"]:checked');
  if (checked && checked.value === 'Other') {
    otherInputWrapper.classList.add('show-animated');
    otherInputWrapper.classList.remove('hidden-animated');
  } else {
    otherInputWrapper.classList.add('hidden-animated');
    otherInputWrapper.classList.remove('show-animated');
  }
}


  hideStatusMessages() {
    if (this.statusDiv) {
      this.statusDiv.classList.add('hidden');
    }
    if (this.statusSuccess) {
      this.statusSuccess.classList.add('hidden');
    }
    if (this.statusError) {
      this.statusError.classList.add('hidden');
    }
  }

  showSuccess() {
    this.hideStatusMessages();
    
    if (this.statusDiv && this.statusSuccess) {
      this.statusDiv.classList.remove('hidden');
      this.statusSuccess.classList.remove('hidden');
    }
  }

  showError(message) {
    this.hideStatusMessages();
    
    if (this.statusDiv && this.statusError) {
      this.statusDiv.classList.remove('hidden');
      this.statusError.classList.remove('hidden');
      
      const errorText = this.statusError.querySelector('span');
      if (errorText) {
        errorText.textContent = message;
      }
    } else {
      alert(message);
    }
  }
}

if (!customElements.get('bulk-order-form')) {
  customElements.define('bulk-order-form', BulkOrderForm);
}